import React, { Component } from "react";
const createGallery = require("./styles/create/01-create-gallery.svg");
const uploadPhotos = require("./styles/create/02-upload-photos.svg");
const sellPhotos = require("./styles/create/03-sell.svg");
const rightarr = require("./styles/create/right-arr.svg");
const geoLogo = require("./styles/powered-by-geo.svg");
const layer = require("./styles/Layer-2.svg");

interface NoEventsViewState {}

interface NoEventsViewProps {
  editMode: boolean;
  organizationName: string;
}

class NoEventsView extends Component<NoEventsViewProps, NoEventsViewState> {
  createGallery = () => (
    <div className="empty-events-container">
      <p className="empty-events-p1">
        {" "}
        Create an event gallery to share and sell photos
      </p>
      <p className="empty-events-p2">
        <div className="ci-row">
          <div className="ci-sin ci-margin">
            <img src={createGallery} />
            <h6 className="ci-label">Create event</h6>

            <span className="vi-arr">
              <img src={rightarr} />
            </span>
          </div>
          <div className="ci-sin ci-margin">
            <img src={uploadPhotos} />
            <h6 className="ci-label">Upload Photos</h6>

            <span className="vi-arr">
              <img src={rightarr} />
            </span>
          </div>
          <div className="ci-sin ci-margin">
            <img src={sellPhotos} />
            <h6 className="ci-label">Sell or share</h6>
          </div>
        </div>
        <button
          className="event-btn"
          onClick={() => window.location.assign("/dashboard/events/new/our")}
          style={{ marginLeft: 20 }}
        >
          Create your first event
        </button>
      </p>
    </div>
  );

  previewGallery = () => {
    return (
      <div className="preview-div">
        <div className="preview-head">
          <span>{this.props.organizationName}</span>
          <span className="preview-powered">
            <img src={geoLogo} style={{ width: 240 }} />
          </span>
        </div>
        <div className="preview-box">
          <img src={layer} style={{ marginTop: 10, width: 38, height: 40 }} />
          <span className="prev-text">
            {this.props.organizationName} hasn't created any photo albums yet
          </span>
        </div>
        <div className="prev-textInfo">
          <span
            className="sell-info"
            style={{ fontWeight: "bold", color: "black" }}
          >
            Geosnapshot powers your photography
          </span>
          <a
            className="sell-info"
            style={{
              fontWeight: "bold",
              color: "#269FA5",
              textDecoration: "underline !important",
              cursor: "pointer"
            }}
            href="http://help.geosnapshot.com/en/collections/485058-customers"
            target="_blank"
          >
            Learn more about GeoSnapShot
          </a>
        </div>
      </div>
    );
  };

  render() {
    if (this.props.editMode) return this.createGallery();
    else return this.previewGallery();
  }
}

export default NoEventsView;
